import request from './index'

// 根据导航 ID查询详情页内容
export const inquireId = (data) => {
  return request({
    method: "GET",
    url: `/api/nsc/front/ndFrontPage/getInfoById/${data.menuId}`,
  })
}

export const algin = (params) => {
  return request({
    method: "GET", //请求方法
    url: "/api/nsc/weroad/getCookie", //请求地址
    params,
  });
};